export const PollToggleIcon = ({ shown }: { shown: boolean }) => (
    <>
        <svg
            className={`h-4 mr-2 transition-all duration-300 absolute top-1/2 transform -translate-y-1/2 ${shown ? 'left-10 rotate-180 fill-primary group-hover:fill-on-primary' : 'left-2 fill-on-primary'}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 10 16"
            aria-hidden="true"
        >
            <path d="M8,12.76h0L2.92,8,8,3.24V12.76m2,0V3.24c0-1.75-2.09-2.66-3.37-1.46L1.56,6.54c-.42,.4-.63,.93-.63,1.46s.21,1.06,.63,1.46l5.08,4.76c1.28,1.2,3.37,.29,3.37-1.46h0Z" />
        </svg>
        <svg
            className={`w-6 h-6 transition-all duration-300 ${shown ? 'fill-primary group-hover:fill-on-primary' : 'fill-on-primary'}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            aria-hidden="true"
        >
            <path d="M5.67,9.75c-.96,0-1.75-.79-1.75-1.75s.79-1.75,1.75-1.75,1.75,.79,1.75,1.75-.79,1.75-1.75,1.75Zm0-2.5c-.41,0-.75,.34-.75,.75s.34,.75,.75,.75,.75-.34,.75-.75-.34-.75-.75-.75Z" />
            <rect x="9" y="7" width="10" height="2" rx=".5" ry=".5" />
            <path d="M24,2c1.1,0,2,.9,2,2V24c0,1.1-.9,2-2,2H4c-1.1,0-2-.9-2-2V4c0-1.1,.9-2,2-2H24m0-2H4C1.79,0,0,1.79,0,4V24c0,2.21,1.79,4,4,4H24c2.21,0,4-1.79,4-4V4c0-2.21-1.79-4-4-4h0Z" />
            <path d="M5.67,15.75c-.96,0-1.75-.79-1.75-1.75s.79-1.75,1.75-1.75,1.75,.79,1.75,1.75-.79,1.75-1.75,1.75Zm0-2.5c-.41,0-.75,.34-.75,.75s.34,.75,.75,.75,.75-.34,.75-.75-.34-.75-.75-.75Z" />
            <rect x="9" y="13" width="14" height="2" rx=".59" ry=".59" />
            <path d="M5.67,21.75c-.96,0-1.75-.79-1.75-1.75s.79-1.75,1.75-1.75,1.75,.79,1.75,1.75-.79,1.75-1.75,1.75Zm0-2.5c-.41,0-.75,.34-.75,.75s.34,.75,.75,.75,.75-.34,.75-.75-.34-.75-.75-.75Z" />
            <rect x="9" y="19" width="6" height="2" rx=".39" ry=".39" />
        </svg>
    </>
);
